import { Injectable } from '@angular/core';
import { AbstractLoggerService} from 'angular-auth-oidc-client';

@Injectable()
export class OidcLoggerService implements AbstractLoggerService {

    logError(message: string, data?: any): void {
        console.error(message, data);
    }

    logWarning(message: string, data?: any): void {
        console.warn(message, data);
    }

    logDebug(message: string, data?: any): void {
        console.debug(message, data);
    }
}